module.exports = __webpack_public_path__ + "img/unzan_uc.235eaee4.svg";